<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options"/>

    <basic-table
      v-if="servicesInTariffs"
      :items="servicesInTariffs"
      :fields="servicesInTariffsFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>

    <FormOnceServices
      :serviceType="serviceType"
      :isTariffs="isTariffs"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :groupList="groupList"
      :isEdit="isEdit"
      :editItem="selectedServices"/>

    <FormPeriodicServices
      :serviceType="serviceType"
      :isTariffs="isTariffs"
      :schemeList="schemeList"
      :policyList="policyList"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :isEdit="isEdit"
      :editItem="selectedServices"/>

    <FormIPtrafficService
      :serviceType="serviceType"
      :isTariffs="isTariffs"
      :schemeList="schemeList"
      :policyList="policyList"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :isEdit="isEdit"
      :editItem="selectedServices"/>

    <FormHotspotServices
      :serviceType="serviceType"
      :isTariffs="isTariffs"
      :policyList="policyList"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :timeRangeList="timeRangeList"
      :isEdit="isEdit"
      :editItem="selectedServices"/>

    <FormDialupServices
      :serviceType="serviceType"
      :isTariffs="isTariffs"
      :schemeList="schemeList"
      :policyList="policyList"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :ipPoolsList="ipPoolsList"
      :timeRangeList="timeRangeList"
      :isEdit="isEdit"
      :editItem="selectedServices"/>

    <FormTelephoneService
      :serviceType="serviceType"
      :isTariffs="isTariffs"
      :schemeList="schemeList"
      :policyList="policyList"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :isEdit="isEdit"
      :editItem="selectedServices"/>

    <FormIPTVService
      :serviceType="serviceType"
      :isTariffs="isTariffs"
      :schemeList="schemeList"
      :policyList="policyList"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :isEdit="isEdit"
      :editItem="selectedServices"/>

    <FormVodService
      :serviceType="serviceType"
      :isTariffs="isTariffs"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :isEdit="isEdit"
      :editItem="selectedServices"/>
  </div>
</template>

<script>
import FormOnceServices from '../formOnceService'
import FormPeriodicServices from '../formPeriodicService'
import FormIPtrafficService from '../formIPtrafficService'
import FormHotspotServices from '../formHotspotService'
import FormDialupServices from '../formDialupService'
import FormTelephoneService from '../formTelephonyService'
import FormIPTVService from '../formIPTVService'
import FormVodService from '../formVodService'

export default {
  components: {
    FormOnceServices,
    FormPeriodicServices,
    FormIPtrafficService,
    FormHotspotServices,
    FormDialupServices,
    FormTelephoneService,
    FormIPTVService,
    FormVodService
  },
  data () {
    return {
      servicesInTariffsFields: [
        {key: 'service_id', label: 'ID', sortable: true},
        {key: 'service_name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'nameServicesType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'comment', label: this.$i18n.t('Comment'), sortable: true},
        {key: 'tariffName', label: this.$i18n.t('Status'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      isTariffs: true,
      isEdit: true,
      serviceType: 0,
      selectedServices: null,
      options: {
        isShowAddButton: false
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    editItem (item) {
      this.selectedServices = null
      this.serviceType = item.service_type
      switch (item.service_type) {
        case 1:
          this.selectedServices = JSON.parse(JSON.stringify(item))
          this.$store.dispatch('Tariffing/GET_ONE_TIME_SERVICE', item.service_id).then(response => {
            this.$set(this.selectedServices, 'cost', 0)
            this.selectedServices.cost = this.$store.getters['Tariffing/ONE_TIME_SERVICE'].once_service_data.cost
            this.selectedServices.invoice_sup_id = this.$store.getters['Tariffing/ONE_TIME_SERVICE'].service_data.invoice_sup_id
            this.selectedServices.drop_from_group = this.$store.getters['Tariffing/ONE_TIME_SERVICE'].once_service_data.drop_from_group
            this.$root.$emit('bv::show::modal', 'modalOnceService', '#btnShow')
          })
          break
        case 2:
          this.selectedServices = JSON.parse(JSON.stringify(item))
          this.$store.dispatch('Tariffing/GET_PERIODIC_SERVICE', item.service_id).then(response => {
            this.$set(this.selectedServices, 'cost', 0)
            this.selectedServices.cost = this.$store.getters['Tariffing/PERIODIC_SERVICE'].periodic_service_data.cost
            this.selectedServices.invoice_sup_id = this.$store.getters['Tariffing/PERIODIC_SERVICE'].service_data.invoice_sup_id
            this.selectedServices.charge_method = this.$store.getters['Tariffing/PERIODIC_SERVICE'].periodic_service_data.charge_method
            this.selectedServices.policy_id = this.$store.getters['Tariffing/PERIODIC_SERVICE'].periodic_service_data.policy_id
            this.selectedServices.scheme_id = this.$store.getters['Tariffing/PERIODIC_SERVICE'].periodic_service_data.scheme_id
            this.$root.$emit('bv::show::modal', 'modalPeriodicService', '#btnShow')
          })
          break
        case 3:
          this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_SERVICES', item)
          this.$store.dispatch('Tariffing/GET_IP_TRAFFIC_SERVICE', item.service_id).then(response => {
            this.selectedServices = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/IP_TRAFFIC_SERVICE']))
            this.$root.$emit('bv::show::modal', 'modalIPtrafficService', '#btnShow')
          })
          break
        case 4:
          this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_SERVICES', item)
          this.$store.dispatch('Tariffing/GET_HOTSPOT_SERVICE', item.service_id).then(response => {
            this.selectedServices = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/HOTSPOT_SERVICE']))
            this.$root.$emit('bv::show::modal', 'modalHotspotService', '#btnShow')
          })
          break
        case 5:
          this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_SERVICES', item)
          this.$store.dispatch('Tariffing/GET_DIALUP_SERVICE', item.service_id).then(response => {
            this.selectedServices = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/DIALUP_SERVICE']))
            this.$set(this.selectedServices.dialup_service_data, 'pool_id', 0)
            this.$root.$emit('bv::show::modal', 'modalDialupService', '#btnShow')
          })
          break
        case 6:
          this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_SERVICES', item)
          this.$store.dispatch('Tariffing/GET_TELEPHONY_SERVICE', item.service_id).then(response => {
            this.selectedServices = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TELEPHONY_SERVICE']))
            this.$root.$emit('bv::show::modal', 'modalTelephoneService', '#btnShow')
          })
          break
        case 8:
          this.$store.dispatch('Tariffing/GET_IPTV_SERVICE', item.service_id).then(response => {
            this.selectedServices = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/IPTV_SERVICE']))
            this.$root.$emit('bv::show::modal', 'modalIPTVService', '#btnShow')
          })
          break
        case 9:
          this.$store.dispatch('Tariffing/GET_VOD_SERVICE', item.service_id).then(response => {
            this.selectedServices = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/VOD_SERVICE']))
            this.$root.$emit('bv::show::modal', 'modalVodService', '#btnShow')
          })
          break
      }
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Service"?'), this.deleteItem, item)
    },
    async deleteItem (item) {
      await this.$store.dispatch('Tariffing/GET_TARIFF_LINKS_COUNT', item.service_id).then(response => {
        let linksCount = this.$store.getters['Tariffing/TARIFF_LINKS_COUNT']
        if (linksCount.links_count > 0) {
          this.$root.$emit('makeToasts', 'warning', this.$i18n.t('Cannot delete service, service links count:') + linksCount.links_count, 'Warning')
        } else {
          let response = this.$store.dispatch('Tariffing/DELETE_SERVICES', item.service_id)
          response.then(response => {
            if (response.data.error) {
              this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            } else {
              setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_SERVICES')
              this.$root.$emit('makeToasts')
            }
          })
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    timeRangeList () {
      let tmp = []
      for (let el of this.$store.getters['Tariffing/TIME_RANGE']) {
        let newEl = {
          value: el.tr_id,
          text: el.name + ' (' + el.tr_id + ')'
        }
        tmp.push(newEl)
      }
      return tmp
    },
    ipPoolsList () {
      let tmp = []
      for (let el of this.$store.getters['Settings/IP_POOLS']) {
        let newEl = {
          value: el.id,
          text: el.name
        }
        tmp.push(newEl)
      }
      return tmp
    },
    schemeList () {
      let tmp = [
        {value: 0, text: '---'}
      ]
      for (let el of this.$store.getters['Tariffing/COEFFICIENT_SCHEME']) {
        let newEl = {
          value: el.id,
          text: el.name
        }
        tmp.push(newEl)
      }
      return tmp
    },
    policyList () {
      let tmp = []
      for (let el of this.$store.getters['Tariffing/CHARGE_POLICIES']) {
        let newEl = {
          value: el.policy_id,
          text: el.name + ' (' + el.policy_id + ')'
        }
        tmp.push(newEl)
      }
      return tmp
    },
    suppliertList () {
      let tmp = [
        {value: 0, text: ''}
      ]
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/COMPANIES']))
      for (let el of copy) {
        let newEl = {
          value: el.id,
          text: el.name
        }
        tmp.push(newEl)
      }
      return tmp
    },
    groupList () {
      let tmp = [
        {value: 0, text: this.$i18n.t('Don`t delete')}
      ]
      for (let el of this.$store.getters['Users/GROUPS']) {
        let newEl = {
          value: el.group_id,
          text: el.group_name + ' (' + el.group_id + ')'
        }
        tmp.push(newEl)
      }
      return tmp
    },
    contractList () {
      let tmp = [
        {value: 0, text: ''}
      ]
      for (let el of this.$store.getters['Tariffing/CONTRACT_TYPE']) {
        let newEl = {
          value: el.id,
          text: el.name
        }
        tmp.push(newEl)
      }
      return tmp
    },
    servicesInTariffs () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/SERVICES']))
      copy = copy.filter(function (value) {
        return value.tariff_id !== 0
      })
      for (let el of copy) {
        for (let elTariffs of this.$store.getters['Tariffing/TARIFFS']) {
          if (el.tariff_id === elTariffs.id) {
            el.tariffName = this.$i18n.t('Tariff plan: "') + elTariffs.name + '"' + ' (' + elTariffs.id + ')'
          }
        }
        switch (el.service_type) {
          case 1:
            el.nameServicesType = this.$i18n.t('One-time service')
            break
          case 2:
            el.nameServicesType = this.$i18n.t('Periodic service')
            break
          case 3:
            el.nameServicesType = this.$i18n.t('IP traffic service')
            break
          case 4:
            el.nameServicesType = this.$i18n.t('Hotspot service')
            break
          case 5:
            el.nameServicesType = this.$i18n.t('Dial-up service')
            break
          case 6:
            el.nameServicesType = this.$i18n.t('Telephony service')
            break
          case 8:
            el.nameServicesType = this.$i18n.t('IPTV service')
            break
          case 9:
            el.nameServicesType = this.$i18n.t('Video on demand')
            break
        }
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_SERVICES')
    this.$store.dispatch('Tariffing/GET_TARIFFS')
    this.$store.dispatch('Users/GET_GROUPS')
    this.$store.dispatch('Tariffing/GET_CONTRACT_TYPE')
    this.$store.dispatch('Settings/GET_COMPANIES')
    this.$store.dispatch('Tariffing/GET_CHARGE_POLICIES')
    this.$store.dispatch('Tariffing/GET_COEFFICIENT_SCHEME')
    this.$store.dispatch('Tariffing/GET_MEDIA_GROUPS')
    this.$store.dispatch('Tariffing/GET_MEDIA_CONTENTS')
    this.$store.dispatch('Settings/GET_IP_POOLS')
    this.$store.dispatch('Tariffing/GET_TIME_RANGE')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/servicesInTariffs/main.vue